import classes from './Diplomat_meeting_map.module.css'
import map from "../../../store/Diplomat/Map3.png"
import logotest from "../../../store/logo.png"
import {useEffect, useState} from "react";
import {CircularProgress} from "@mui/material";
import axios from "axios";
import {path} from "../../../routes";
import Diplomat_Detail from "./Diplomat_Detail";

const Diplomat_meeting_map = (props) =>{
    const [meetings, setMeetings] = useState([]);
    const [loading, setLoading] = useState(false);

    const [pragueA, setPragueA] = useState([])
    const [pragueB, setPragueB] = useState([])
    const [pragueC, setPragueC] = useState([])
    const [pragueD, setPragueD] = useState([])

    const [viennaI, setViennaI] = useState([])
    const [viennaII, setViennaII] = useState([])

    const [paris, setParis] = useState([])
    const [madrid, setMadrid] = useState([])
    const [rome, setRome] = useState([])
    const [berlin, setBerlin] = useState([])
    const [london, setLondon] = useState([])

    const [belvedereI, setBelvedereI] = useState([])
    const [belvedereII, setBelvedereII] = useState([])
    const [belvedereIII, setBelvedereIII] = useState([])
    const [belvedereIV, setBelvedereIV] = useState([])
    const [belvedereV, setBelvedereV] = useState([])
    const [belvedereVI, setBelvedereVI] = useState([])

    const [loretaI, setLoretaI] = useState([])
    const [loretaII, setLoretaII] = useState([])

    const [sophia, setSophia] = useState([])
    const [cracowI, setCracowI] = useState([])
    const [cracowII, setCracowII] = useState([])
    const [budapest, setBudapest] = useState([])

    const resetRoom = () =>{
        setPragueA([])
        setPragueB([])
        setPragueC([])
        setPragueD([])
        setViennaI([])
        setViennaII([])
        setParis([])
        setMadrid([])
        setRome([])
        setBerlin([])
        setLondon([])
        setBelvedereI([])
        setBelvedereII([])
        setBelvedereIII([])
        setBelvedereIV([])
        setBelvedereV([])
        setBelvedereVI([])
        setLoretaI([])
        setLoretaII([])
        setSophia([])
        setCracowI([])
        setCracowII([])
        setBudapest([])
    }


    const sort_handler = (field) => {
        resetRoom()
        for (let i = 0; i < field.length; i++) {
            let tmp = field[i].room
            //console.warn(field[i])
            //console.warn(`"${tmp}"`)
            if (tmp == "PRAGUE A"){setPragueA([field[i]])}
            if (tmp == "PRAGUE B"){setPragueB([field[i]])}
            if (tmp == "PRAGUE C"){setPragueC([field[i]])}
            if (tmp == "PRAGUE D"){setPragueD([field[i]])}
            if (tmp == "VIENNA I"){setViennaI([field[i]])}
            if (tmp == "VIENNA II"){setViennaII([field[i]])}
            if (tmp == "PARIS"){setParis([field[i]])}
            if (tmp == "MADRID"){setMadrid([field[i]])}
            if (tmp == "ROME"){setRome([field[i]])}
            if (tmp == "BERLIN"){setBerlin([field[i]])}
            if (tmp == "LONDON"){setLondon([field[i]])}
            if (tmp == "BELVEDERE I"){setBelvedereI([field[i]])}
            if (tmp == "BELVEDERE II"){setBelvedereII([field[i]])}
            if (tmp == "BELVEDERE III"){setBelvedereIII([field[i]])}
            if (tmp == "BELVEDERE IV"){setBelvedereIV([field[i]])}
            if (tmp == "BELVEDERE V"){setBelvedereV([field[i]])}
            if (tmp == "BELVEDERE VI"){setBelvedereVI([field[i]])}
            if (tmp == "LORETA I"){setLoretaI([field[i]])}
            if (tmp == "LORETA II"){setLoretaII([field[i]])}
            if (tmp == "SOPHIA"){setSophia([field[i]])}
            if (tmp == "CRACOW I"){setCracowI([field[i]])}
            if (tmp == "CRACOW II"){setCracowII([field[i]])}
            if (tmp == "BUDAPEST"){setBudapest([field[i]])}
        }
    }

    const fetch_meetings = async (orgIDToUse) =>{
        setLoading(true)
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        const actTime = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}T${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds() ).padStart(2, "0")}`;

        const fallbackOrgId = 'AC44260C-8496-4F02-9ECA-2B19F3C32726';
        const orgID = orgIDToUse || props.orgID || fallbackOrgId;

        const response = await axios.get(`${path}/getRecordsNowV2?orgID=${encodeURIComponent(orgID)}&day=${encodeURIComponent(actTime)}`);
        setMeetings(response.data)
        sort_handler(response.data)
        setLoading(false)
    }

    useEffect(()=>{
        fetch_meetings(props.orgID)
    },[props.orgID])

    return <>
        {!loading && <div className={classes.main}>
            <img src={map} alt={"Diplomat"}/>
            {pragueA.length > 0 && <div className={`${classes.room} ${classes.PRGA}`}>
                <Diplomat_Detail data={pragueA} />
            </div>}
            {pragueB.length > 0 && <div className={`${classes.room} ${classes.PRGB}`}>
                <Diplomat_Detail data={pragueB} />
            </div>}
            {pragueC.length > 0 && <div className={`${classes.room} ${classes.PRGC}`}>
                <Diplomat_Detail data={pragueC} />
            </div>}
            {pragueD.length > 0 && <div className={`${classes.room} ${classes.PRGD}`}>
                <Diplomat_Detail data={pragueD} />
            </div>}
            {viennaI.length > 0 && <div className={`${classes.room} ${classes.VIEI}`}>
                <Diplomat_Detail data={viennaI} />
            </div>}
            {viennaII.length > 0 && <div className={`${classes.room} ${classes.VIEII}`}>
                <Diplomat_Detail data={viennaII} />
            </div>}
            {paris.length > 0 && <div className={`${classes.room} ${classes.PAR}`}>
                <Diplomat_Detail data={paris} />
            </div>}
            {madrid.length > 0 && <div className={`${classes.room} ${classes.MAD}`}>
                <Diplomat_Detail data={madrid} />
            </div>}
            {rome.length > 0 && <div className={`${classes.room} ${classes.ROM}`}>
                <Diplomat_Detail data={rome} />
            </div>}
            {berlin.length > 0 && <div className={`${classes.room} ${classes.BER}`}>
                <Diplomat_Detail data={berlin} />
            </div>}
            {london.length > 0 && <div className={`${classes.room} ${classes.LON}`}>
                <Diplomat_Detail data={london} />
            </div>}
            {belvedereI.length > 0 && <div className={`${classes.room} ${classes.BELI}`}>
                <Diplomat_Detail data={belvedereI} />
            </div>}
            {belvedereII.length > 0 && <div className={`${classes.room} ${classes.BELII}`}>
                <Diplomat_Detail data={belvedereII} />
            </div>}
            {belvedereIII.length > 0 && <div className={`${classes.room} ${classes.BELIII}`}>
                <Diplomat_Detail data={belvedereIII} />
            </div>}
            {belvedereIV.length > 0 && <div className={`${classes.room} ${classes.BELIV}`}>
                <Diplomat_Detail data={belvedereIV} />
            </div>}
            {belvedereV.length > 0 && <div className={`${classes.room} ${classes.BELV}`}>
                <Diplomat_Detail data={belvedereV} />
            </div>}
            {belvedereVI.length > 0 && <div className={`${classes.room} ${classes.BELVI}`}>
                <Diplomat_Detail data={belvedereVI} />
            </div>}
            {loretaI.length > 0 && <div className={`${classes.room} ${classes.LORI}`}>
                <Diplomat_Detail data={loretaI} />
            </div>}
            {loretaII.length > 0 && <div className={`${classes.room} ${classes.LORII}`}>
                <Diplomat_Detail data={loretaII} />
            </div>}
            {sophia.length > 0 && <div className={`${classes.room} ${classes.SOP}`}>
                <Diplomat_Detail data={sophia} />
            </div>}
            {cracowI.length > 0 && <div className={`${classes.room} ${classes.CRAI}`}>
                <Diplomat_Detail data={cracowI} />
            </div>}
            {cracowII.length > 0 && <div className={`${classes.room} ${classes.CRAII}`}>
                <Diplomat_Detail data={cracowII} />
            </div>}
            {budapest.length > 0 && <div className={`${classes.room} ${classes.BUD}`}>
                <Diplomat_Detail data={budapest} />
            </div>}
        </div>}
        {loading && <CircularProgress/>}
    </>

}
export default Diplomat_meeting_map;